import { useMemo } from 'react';
import { User } from '../../../graphql/graphql';
import { useAppContext } from '../../../Services/AppContext';
import { UserEditedMeta } from '../../../Components/PatientProfile/PatientProfileParts/PatientProfileInformation';
import { getMomentDate } from '../../../Utils/dates.util';
import {
	getUsersEMSO,
	getUsersJMBG,
	getUsersPESEL,
	getUsersTAJ,
} from '../../User/Services/userMeta.service';

export default function usePatientIdentification(
	user: User | UserEditedMeta | null,
) {
	const { globalTemplate, dateFormatMoment } = useAppContext();

	const identification: { title?: string; value?: string } = useMemo(() => {
		const birthNumber =
			user?.profile?.formattedBirthNumber ||
			user?.profile?.birthNumber ||
			undefined;
		const birthDate = user?.profile?.birthDate
			? getMomentDate(user?.profile?.birthDate).format(dateFormatMoment)
			: undefined;

		switch (globalTemplate) {
			case 'peru':
			case 'ecuador':
			case 'mexico':
			case 'colombia':
				return {
					title: 'base.shared.dateOfBirth',
					value: birthDate,
				};
			case 'hungary':
				return {
					title: 'TAJ',
					value: getUsersTAJ(user),
				};
			case 'poland':
				return {
					title: 'base.pesel',
					value: getUsersPESEL(user),
				};
			case 'slovenia':
				return {
					title: 'base.emso',
					value: getUsersEMSO(user),
				};
			case 'serbia':
				return {
					title: 'base.jmbg',
					value: getUsersJMBG(user),
				};
			case 'slovakia':
			case 'czechia':
			default:
				return {
					title: 'base.shared.birthNumberShort',
					value: birthNumber,
				};
		}
	}, [user]);

	return {
		identification,
	};
}
